module.exports = {
    LowD: {
        wholeUp: ['C6'],
        halfUp: ['F5', 'G#5', 'C#6'],
        blow: ['D3', 'F#3', 'A3', 'D4', 'F#4', 'A4', 'D5', 'F#5', 'A5', 'D6'],
        draw: ['E3', 'A3', 'C#4', 'E4', 'G4', 'B4', 'C#5', 'E5', 'G5', 'B5'],
        halfDown: ['D#3', 'G#4', 'C4', 'D#4', 'A#4'],
        wholeDown: ['G3', 'B3'],
        wholeHalfDown: ['A#3']
    },
    LowEb: {
        wholeUp: ['Db6'],
        halfUp: ['Gb5', 'A5', 'D6'],
        blow: ['Eb3', 'G3', 'Bb3', 'Eb4', 'G4', 'Bb4', 'Eb5', 'G5', 'Bb5', 'Eb6'],
        draw: ['F3', 'Bb3', 'D4', 'F4', 'Ab4', 'C5', 'D5', 'F5', 'Ab5', 'C6'],
        halfDown: ['E3', 'A3', 'Db4', 'E4', 'B4'],
        wholeDown: ['Ab3', 'C4'],
        wholeHalfDown: ['B3']
    },
    LowE: {
        wholeUp: ['D6'],
        halfUp: ['G5', 'A#5', 'D#6'],
        blow: ['E3', 'G#3', 'B3', 'E4', 'G#4', 'B4', 'E5', 'G#5', 'B5', 'E6'],
        draw: ['F#3', 'B3', 'D#4', 'F#4', 'A4', 'C#5', 'D#5', 'F#5', 'A5', 'C#6'],
        halfDown: ['F3', 'A#3', 'D4', 'F4', 'C5'],
        wholeDown: ['A3', 'C#4'],
        wholeHalfDown: ['C4']
    },
    LowF: {
        wholeUp: ['Eb6'],
        halfUp: ['Ab5', 'B5', 'E6'],
        blow: ['F3', 'A3', 'C4', 'F4', 'A4', 'C5', 'F5', 'A5', 'C6', 'F6'],
        draw: ['G3', 'C4', 'E4', 'G4', 'Bb4', 'D5', 'E5', 'G5', 'Bb5', 'D6'],
        halfDown: ['Gb3', 'B3', 'Eb4', 'Gb4', 'Db5'],
        wholeDown: ['Bb3', 'D4'],
        wholeHalfDown: ['Db4']
    },
    'LowF#': {
        wholeUp: ['E6'],
        halfUp: ['A5', 'C6', 'F6'],
        blow: ['F#3', 'A#3', 'C#4', 'F#4', 'A#4', 'C#5', 'F#5', 'A#5', 'C#6', 'F#6'],
        draw: ['G#3', 'C#4', 'F4', 'G#4', 'B4', 'D#5', 'F5', 'G#5', 'B5', 'D#6'],
        halfDown: ['G3', 'C4', 'E4', 'G4', 'D5'],
        wholeDown: ['B3', 'D#4'],
        wholeHalfDown: ['D4']
    },
    LowG: {
        wholeUp: ['F6'],
        halfUp: ['A#5', 'C#6', 'F#6'],
        blow: ['G3', 'B3', 'D4', 'G4', 'B4', 'D5', 'G5', 'B5', 'D6', 'G6'],
        draw: ['A3', 'D4', 'F#4', 'A4', 'C5', 'E5', 'F#5', 'A5', 'C6', 'E6'],
        halfDown: ['G#3', 'C#4', 'F4', 'G#4', 'D#5'],
        wholeDown: ['C4', 'E4'],
        wholeHalfDown: ['D#4']
    },
    Ab: {
        wholeUp: ['Gb6'],
        halfUp: ['B5', 'D6', 'G6'],
        blow: ['Ab3', 'C4', 'Eb4', 'Ab4', 'C5', 'Eb5', 'Ab5', 'C6', 'Eb6', 'Ab6'],
        draw: ['Bb3', 'Eb4', 'G4', 'Bb4', 'Db5', 'F5', 'G5', 'Bb5', 'Db6', 'F6'],
        halfDown: ['A3', 'D4', 'Gb4', 'A4', 'E5'],
        wholeDown: ['Db4', 'F4'],
        wholeHalfDown: ['E4']
    },
    A: {
        wholeUp: ['G6'],
        halfUp: ['C6', 'D#6', 'G#6'],
        blow: ['A3', 'C#4', 'E4', 'A4', 'C#5', 'E5', 'A5', 'C#6', 'E6', 'A6'],
        draw: ['B3', 'E4', 'G#4', 'B4', 'D5', 'F#5', 'G#5', 'B5', 'D6', 'F#6'],
        halfDown: ['A#3', 'D#4', 'G4', 'A#4', 'F5'],
        wholeDown: ['D4', 'F#4'],
        wholeHalfDown: ['F4']
    },
    Bb: {
        wholeUp: ['Ab6'],
        halfUp: ['Db6', 'E6', 'A6'],
        blow: ['Bb3', 'D4', 'F4', 'Bb4', 'D5', 'F5', 'Bb5', 'D6', 'F6', 'Bb6'],
        draw: ['C4', 'F4', 'A4', 'C5', 'Eb5', 'G5', 'A5', 'C6', 'Eb6', 'G6'],
        halfDown: ['B3', 'E4', 'Ab4', 'B4', 'Gb5'],
        wholeDown: ['Eb4', 'G4'],
        wholeHalfDown: ['Gb4']
    },
    B: {
        wholeUp: ['A6'],
        halfUp: ['D6', 'F6', 'A#6'],
        blow: ['B3', 'D#4', 'F#4', 'B4', 'D#5', 'F#5', 'B5', 'D#6', 'F#6', 'B6'],
        draw: ['C#4', 'F#4', 'A#4', 'C#5', 'E5', 'G#5', 'A#5', 'C#6', 'E6', 'G#6'],
        halfDown: ['C4', 'F4', 'A4', 'C5', 'G5'],
        wholeDown: ['E4', 'G#4'],
        wholeHalfDown: ['G4']
    },
    C: {
        wholeUp: ['Bb6'],
        halfUp: ['Eb6', 'Gb6', 'B6'],
        blow: ['C4', 'E4', 'G4', 'C5', 'E5', 'G5', 'C6', 'E6', 'G6', 'C7'],
        draw: ['D4', 'G4', 'B4', 'D5', 'F5', 'A5', 'B5', 'D6', 'F6', 'A6'],
        halfDown: ['Db4', 'Gb4', 'Bb4', 'Db5', 'Ab5'],
        wholeDown: ['F4', 'A4'],
        wholeHalfDown: ['Ab4']
    },
    Db: {
        wholeUp: ['B6'],
        halfUp: ['E6', 'G6', 'C7'],
        blow: ['Db4', 'F4', 'Ab4', 'Db5', 'F5', 'Ab5', 'Db6', 'F6', 'Ab6', 'Db7'],
        draw: ['Eb4', 'Ab4', 'C5', 'Eb5', 'Gb5', 'Bb5', 'C6', 'Eb6', 'Gb6', 'Bb6'],
        halfDown: ['D4', 'G4', 'B4', 'D5', 'A5'],
        wholeDown: ['Gb4', 'Bb4'],
        wholeHalfDown: ['A4']
    },
    D: {
        wholeUp: ['C7'],
        halfUp: ['F6', 'G#6', 'C#7'],
        blow: ['D4', 'F#4', 'A4', 'D5', 'F#5', 'A5', 'D6', 'F#6', 'A6', 'D7'],
        draw: ['E4', 'A4', 'C#5', 'E5', 'G5', 'B5', 'C#6', 'E6', 'G6', 'B6'],
        halfDown: ['D#4', 'G#4', 'C5', 'D#5', 'A#5'],
        wholeDown: ['G4', 'B4'],
        wholeHalfDown: ['A#4']
    },
    Eb: {
        wholeUp: ['Db7'],
        halfUp: ['Gb6', 'A6', 'D7'],
        blow: ['Eb4', 'G4', 'Bb4', 'Eb5', 'G5', 'Bb5', 'Eb6', 'G6', 'Bb6', 'Eb7'],
        draw: ['F4', 'Bb4', 'D5', 'F5', 'Ab5', 'C6', 'D6', 'F6', 'Ab6', 'C7'],
        halfDown: ['E4', 'A4', 'Db5', 'E5', 'B5'],
        wholeDown: ['Ab4', 'C5'],
        wholeHalfDown: ['B4']
    },
    E: {
        wholeUp: ['D7'],
        halfUp: ['G6', 'A#6', 'D#7'],
        blow: ['E4', 'G#4', 'B4', 'E5', 'G#5', 'B5', 'E6', 'G#6', 'B6', 'E7'],
        draw: ['F#4', 'B4', 'D#5', 'F#5', 'A5', 'C#6', 'D#6', 'F#6', 'A6', 'C#7'],
        halfDown: ['F4', 'A#4', 'D5', 'F5', 'C6'],
        wholeDown: ['A4', 'C#5'],
        wholeHalfDown: ['C5']
    },
    F: {
        wholeUp: ['Eb7'],
        halfUp: ['Ab6', 'B6', 'E7'],
        blow: ['F4', 'A4', 'C5', 'F5', 'A5', 'C6', 'F6', 'A6', 'C7', 'F7'],
        draw: ['G4', 'C5', 'E5', 'G5', 'Bb5', 'D6', 'E6', 'G6', 'Bb6', 'D7'],
        halfDown: ['Gb4', 'B4', 'Eb5', 'Gb5', 'Db6'],
        wholeDown: ['Bb4', 'D5'],
        wholeHalfDown: ['Db5']
    },
    'F#': {
        wholeUp: ['E7'],
        halfUp: ['A6', 'C7', 'F7'],
        blow: ['F#4', 'A#4', 'C#5', 'F#5', 'A#5', 'C#6', 'F#6', 'A#6', 'C#7', 'F#7'],
        draw: ['G#4', 'C#5', 'F5', 'G#5', 'B5', 'D#6', 'F6', 'G#6', 'B6', 'D#7'],
        halfDown: ['G4', 'C5', 'E5', 'G5', 'D6'],
        wholeDown: ['B4', 'D#5'],
        wholeHalfDown: ['D5']
    },
    G: {
        wholeUp: ['F7'],
        halfUp: ['A#6', 'C#7', 'F#7'],
        blow: ['G4', 'B4', 'D5', 'G5', 'B5', 'D6', 'G6', 'B6', 'D7', 'G7'],
        draw: ['A4', 'D5', 'F#5', 'A5', 'C6', 'E6', 'F#6', 'A6', 'C7', 'E7'],
        halfDown: ['G#4', 'C#5', 'F5', 'G#5', 'D#6'],
        wholeDown: ['C5', 'E5'],
        wholeHalfDown: ['D#5']
    }
};
